var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EAccountType } from "../../../enum/EUpperSupAccountType";
import Add from "../Add.vue";
import { cloneDeep } from "lodash";
var RecordTable = (function (_super) {
    __extends(RecordTable, _super);
    function RecordTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eAccountType = EAccountType;
        _this.height = document.documentElement.clientHeight - 370;
        return _this;
    }
    RecordTable.prototype.toCheck = function (row) {
        this.$emit("add-tab", {
            component: Add,
            title: '添加对账单',
            showExist: true,
            name: 'add-upper-sup-check',
            cprops: {
                detail: __assign({}, cloneDeep(this.detail), { organ_id: row.organ_id, organ_name: row.organ_name, depot_id: row.depot_id, depot_name: row.depot_name })
            }
        });
    };
    __decorate([
        Prop({
            required: true
        })
    ], RecordTable.prototype, "type", void 0);
    __decorate([
        Prop({
            type: Array,
            required: true
        })
    ], RecordTable.prototype, "data", void 0);
    __decorate([
        Prop({
            type: Boolean
        })
    ], RecordTable.prototype, "canCheck", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], RecordTable.prototype, "detail", void 0);
    RecordTable = __decorate([
        Component
    ], RecordTable);
    return RecordTable;
}(Vue));
export default RecordTable;
